<script>
import { tasksStore } from './store/taskStore'
import { dateTimeZoneOffset } from '../../../../javascripts/helpers/timeZoneOffsetHelper';

import { mapState, mapActions, mapGetters } from 'vuex';

export default{
  props: {
    initialTasks: {
      type: Array,
      default: () => []
    },
    initialDate: {
      type: String,
      default: null
    },
    urlBase: String,
    tenantPresent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('taskStoreModule', ['tasks', 'loading', 'dateSelected', 'error']),
    ...mapGetters('taskStoreModule', ['getUnArchivedTasks'])
  },
  methods: {
    ...mapActions('taskStoreModule', ['initStore', 'addTask', 'setDateSelected']),
    getInitialData(){
      let date = null
      if(this.initialDate == null || this.initialDate == ""){
        date = new Date()
      }else{
        date = new Date(this.initialDate)
        let time = date.getTime()
        let timestamp = date.getTimezoneOffset()*60*1000
        time = time + timestamp;
        date.setTime(time);
      }
      this.initStore({tasks: this.initialTasks, dateSelected: date, urlBase: this.urlBase, tenantPresent: this.tenantPresent})
    }
  },
  beforeMount(){
    this.$store.registerModule('taskStoreModule', tasksStore)
    this.getInitialData();
    window.onpopstate = e => {
      const params = new URLSearchParams(document.location.search)
      const date = dateTimeZoneOffset(params.get('date'))
      this.setDateSelected({date: date})
    };
  },
  i18n: {
    messages:{
      "pt-BR": {
        noActivities: 'Não há tarefas cadastradas para o dia selecionado'
      },
      en: {
        noActivities: 'There are not saved tasks for selected day'
      }
    }
  }
}
</script>